/**
 * Что показывает главная (PROJECT_SPEC: первый экран ведёт к действию, а не к пустому списку):
 * - first-step — ни связей, ни отправленных ссылок: «С кем у тебя незакрытый долг?»;
 * - pending — связей нет, но ссылки отправлены: список «Ожидают»;
 * - empty — пользователь нажал «Пока просто посмотреть»: обычный пустой экран;
 * - list — есть связи.
 * Пришедший по inv_ сюда не попадает: поверх главной открыт AcceptInvitationScreen.
 */
export type HomeState = 'first-step' | 'pending' | 'empty' | 'list';

export function homeState({
  connections,
  pendingInvites,
  skipped,
}: {
  connections: number;
  pendingInvites: number;
  skipped: boolean;
}): HomeState {
  if (connections > 0) return 'list';
  if (pendingInvites > 0) return 'pending';
  return skipped ? 'empty' : 'first-step';
}

/** «Пока просто посмотреть» помним до перезапуска Mini App: завтра первый шаг покажем снова. */
const SKIPPED_KEY = 'debtbot:onboarding-skipped';

export function loadOnboardingSkipped(): boolean {
  try {
    return sessionStorage.getItem(SKIPPED_KEY) === '1';
  } catch {
    return false;
  }
}

export function saveOnboardingSkipped(): void {
  try {
    sessionStorage.setItem(SKIPPED_KEY, '1');
  } catch {
    // Хранилище недоступно — экран первого шага просто вернётся при следующем рендере списка
  }
}
